import { render, staticRenderFns } from "./garantiasExpiracion.vue?vue&type=template&id=3b91baf4&scoped=true"
import script from "./garantiasExpiracion.vue?vue&type=script&lang=js"
export * from "./garantiasExpiracion.vue?vue&type=script&lang=js"
import style0 from "./garantiasExpiracion.vue?vue&type=style&index=0&id=3b91baf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b91baf4",
  null
  
)

export default component.exports